import { css } from 'styled-components';
import { fontSizes, space } from '../../theme';

const getRules = ({
  fontSize,
  btnSpace,
  height,
  fullWidth
}) => css(["font-size:", ";line-height:", ";height:", ";padding:", ";width:", ";"], () => `${fontSizes[fontSize]}px`, () => `${height}px`, () => `${height}px`, () => `0 ${space[btnSpace]}px`, () => fullWidth && '100%');

const getSize = ({
  size,
  fullWidth
}) => {
  switch (size) {
    case 'sm':
      return getRules({
        fontSize: 2,
        btnSpace: 4,
        height: 32,
        fullWidth
      });

    case 'md':
      return getRules({
        fontSize: 2,
        btnSpace: 4,
        height: 40,
        fullWidth
      });

    case 'lg':
      return getRules({
        fontSize: 3,
        btnSpace: 6,
        height: 48,
        fullWidth
      });

    case 'xl':
      return getRules({
        fontSize: 3,
        btnSpace: 6,
        height: 56,
        fullWidth
      });

    default:
      return getRules({
        fontSize: 2,
        btnSpace: 4,
        height: 32,
        fullWidth
      });
  }
};

export default getSize;